<div class="list-group">
  <a *ngFor="let poll of polls" [routerLink]="['poll', poll.id, -1]" class="list-group-item">{{poll.title}}</a>
</div>
<button *ngIf="isAdmin" type="button" class='btn btn-secondary btn-block' (click)="createPoll()">Create new poll</button>
